import {
    C_ID_UPDATED,
    C_UPDATED,
    C_INVALIDATED,
    C_URATE_UPDATED,
    C_UCRATE_UPDATED,
    C_CRATE_UPDATED,
    C_UTC_UPDATED,
    C_SET_LEFT_RFS,
    C_SET_RIGHT_RFS,
} from "../Constants/cConstants.js";

const cReducer = (state = { c_id: null, c_tc: null, c_gtc: null, c_comp: null, c_ucomp: null, c_analysis: null, c_l_red_flags: null, c_r_red_flags: null }, action) => {
    switch(action.type) {
        case C_URATE_UPDATED:
            return {
                ...state,
                c_gtc: action.payload,
            }
        case C_CRATE_UPDATED:
            return {
                ...state,
                c_comp: action.payload,
            }
        case C_UCRATE_UPDATED:
            return {
                ...state,
                c_ucomp: action.payload,
            }
        case C_UTC_UPDATED:
            return {
                ...state,
                c_tc: action.payload,
            }
        case C_ID_UPDATED:
            return {
                ...state,
                c_id: action.payload.c_id,
                c_tc: null,
                c_gtc: null,
                c_comp: null,
                c_analysis: null,
                c_ucomp: null,
                c_l_red_flags: null,
                c_r_red_flags: null,
            }
        case C_UPDATED:
            let newState = {
                ...state,
                c_tc: action.payload.usertc,
                c_analysis: action.payload.analysis,
                c_l_red_flags: null,
                c_r_red_flags: null,
            };

            if (action.payload.gentc){
                newState.c_gtc = action.payload.gentc;
            } else {
                newState.c_gtc = null;
            }

            if (action.payload.company){
                newState.c_comp = action.payload.company;
            } else {
                newState.c_comp = null;
            }
            
            if (action.payload.ucomp){
                newState.c_ucomp = action.payload.ucomp;
            } else {
                newState.c_ucomp = null;
            }
            
            return newState;
        case C_INVALIDATED:
            return {
                ...state,
                c_tc: null,
                c_id: null,
                c_gtc: null,
                c_comp: null,
                c_analysis: null,
                c_ucomp: null,
                c_l_red_flags: null,
                c_r_red_flags: null,
            }
        case C_SET_LEFT_RFS:
            return {
                ...state,
                c_l_red_flags: action.payload,
            }
        case C_SET_RIGHT_RFS:
            return {
                ...state,
                c_r_red_flags: action.payload,
            }
        
        default:
            return state;
    }
};

export { cReducer };
